import { render, staticRenderFns } from "./aiReportPanel.vue?vue&type=template&id=71bb36b6&scoped=true&"
import script from "./aiReportPanel.vue?vue&type=script&lang=js&"
export * from "./aiReportPanel.vue?vue&type=script&lang=js&"
import style0 from "./aiReportPanel.vue?vue&type=style&index=0&id=71bb36b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb36b6",
  null
  
)

export default component.exports